(() => {
  if (customElements.get('launch-countdown')) return;
  class LaunchCountdown extends HTMLElement {
    connectedCallback() {
      clearInterval(this.interval);
      this.timer = this.querySelector('[data-timer]');
      this.expired = this.querySelector('[data-expired]');
      this.invalid = this.querySelector('[data-invalid]');
      this.units = Object.fromEntries(['days', 'hours', 'minutes', 'seconds'].map(name => [name, this.querySelector(`[data-unit="${name}"]`)]));
      this.target = this.parseTarget(this.dataset.launchAt || '');
      this.timer.hidden = true;
      this.expired.hidden = true;
      if (this.invalid) this.invalid.hidden = this.target !== null;
      if (this.target === null) return;
      if (this.tick()) this.interval = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    parseTarget(value) {
      const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):00(Z|[+-]\d{2}:\d{2})$/);
      if (!match) return null;
      const [, y, m, d, h, min, zone] = match;
      const calendar = new Date(Date.UTC(+y, +m - 1, +d));
      if (calendar.getUTCFullYear() !== +y || calendar.getUTCMonth() !== +m - 1 || calendar.getUTCDate() !== +d || +h > 23 || +min > 59) return null;
      if (zone !== 'Z') {
        const [zh, zm] = zone.slice(1).split(':').map(Number);
        if (zh > 14 || zm > 59 || (zh === 14 && zm !== 0)) return null;
      }
      const timestamp = Date.parse(value.trim());
      return Number.isFinite(timestamp) ? timestamp : null;
    }
    tick() {
      const remaining = Math.max(0, Math.ceil((this.target - Date.now()) / 1000));
      if (!remaining) {
        this.timer.hidden = true;
        this.expired.hidden = false;
        clearInterval(this.interval);
        return false;
      }
      const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
      Object.keys(this.units).forEach((name, index) => { if (this.units[name]) this.units[name].textContent = String(values[index]).padStart(2, '0'); });
      this.timer.hidden = false;
      this.timer.setAttribute('aria-label', `${values[0]} days, ${values[1]} hours, ${values[2]} minutes until launch`);
      return true;
    }
  }
  customElements.define('launch-countdown', LaunchCountdown);
})();
